(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contador"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuup-results-counter')) {
    class NuupResultsCounter extends HTMLElement {
      connectedCallback() {
        this.values = Array.from(this.querySelectorAll('[data-count-target]'));
        this.duration = Number(this.dataset.duration) || 1400;
        this.hasRun = false;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!this.values.length) return;

        if (this.reducedMotion || !('IntersectionObserver' in window)) {
          this.finish();
          return;
        }

        this.values.forEach((value) => {
          value.textContent = '0';
        });

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting || this.hasRun) return;
              this.hasRun = true;
              this.animate();
              this.observer.disconnect();
            });
          },
          { threshold: 0.3 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      animate() {
        const start = performance.now();

        const tick = (now) => {
          const elapsed = Math.min(1, (now - start) / this.duration);
          const eased = 1 - Math.pow(1 - elapsed, 3);

          this.values.forEach((value) => {
            const target = Number(value.dataset.countTarget) || 0;
            value.textContent = Math.round(target * eased).toLocaleString();
          });

          if (elapsed < 1) {
            requestAnimationFrame(tick);
          } else {
            this.finish();
          }
        };

        requestAnimationFrame(tick);
      }

      finish() {
        this.values.forEach((value) => {
          const target = Number(value.dataset.countTarget) || 0;
          value.textContent = Math.round(target).toLocaleString();
        });
      }
    }

    customElements.define('nuup-results-counter', NuupResultsCounter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuup-concern-collection')) {
  class NuupConcernCollection extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.tabs = Array.from(this.querySelectorAll('[data-concern-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-concern-panel]'));
      this.viewAll = this.querySelector('[data-view-all]');
      this.prevButton = this.querySelector('[data-prev]');
      this.nextButton = this.querySelector('[data-next]');
      this.currentEl = this.querySelector('[data-current]');
      this.totalEl = this.querySelector('[data-total]');
      this.progressFill = this.querySelector('[data-progress-fill]');
      this.activePanelIndex = 0;
      this.panelIndexes = new Map();
      this.scrollFrames = new Map();

      this.onTabClick = this.onTabClick.bind(this);
      this.onTabKeydown = this.onTabKeydown.bind(this);
      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onResize = this.onResize.bind(this);

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onTabClick);
        tab.addEventListener('keydown', this.onTabKeydown);
      });

      this.panels.forEach((panel, panelIndex) => {
        this.panelIndexes.set(panelIndex, 0);
        const viewport = panel.querySelector('[data-products-viewport]');
        if (viewport) {
          const handler = () => this.onProductsScroll(panelIndex, viewport);
          viewport.addEventListener('scroll', handler, { passive: true });
          viewport.nuupScrollHandler = handler;
        }
      });

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNext);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      window.addEventListener('resize', this.onResize, { passive: true });

      this.activatePanel(0, false);
    }

    disconnectedCallback() {
      this.tabs?.forEach((tab) => {
        tab.removeEventListener('click', this.onTabClick);
        tab.removeEventListener('keydown', this.onTabKeydown);
      });

      this.panels?.forEach((panel) => {
        const viewport = panel.querySelector('[data-products-viewport]');
        if (viewport?.nuupScrollHandler) viewport.removeEventListener('scroll', viewport.nuupScrollHandler);
      });

      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNext);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      window.removeEventListener('resize', this.onResize);
      this.scrollFrames?.forEach((frame) => cancelAnimationFrame(frame));
    }

    onTabClick(event) {
      this.activatePanel(Number(event.currentTarget.dataset.concernTab), true);
    }

    onTabKeydown(event) {
      const currentIndex = Number(event.currentTarget.dataset.concernTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;

      if (nextIndex !== currentIndex) {
        event.preventDefault();
        this.tabs[nextIndex].focus();
        this.activatePanel(nextIndex, true);
      }
    }

    onPrev() {
      this.moveProducts(-1);
    }

    onNext() {
      this.moveProducts(1);
    }

    onResize() {
      const panel = this.getActivePanel();
      const metrics = this.getSliderMetrics(panel);
      const stored = this.panelIndexes.get(this.activePanelIndex) || 0;
      const clamped = Math.min(stored, metrics.maxStartIndex);
      this.panelIndexes.set(this.activePanelIndex, clamped);
      this.scrollToIndex(panel, clamped, false);
      this.updateFooter();
    }

    onBlockSelect(event) {
      const blockId = event.detail?.blockId;
      if (!blockId) return;
      const panelIndex = this.panels.findIndex((panel) => panel.dataset.blockId === blockId);
      if (panelIndex >= 0) this.activatePanel(panelIndex, false);
    }

    onProductsScroll(panelIndex, viewport) {
      const existing = this.scrollFrames.get(panelIndex);
      if (existing) cancelAnimationFrame(existing);

      const frame = requestAnimationFrame(() => {
        const panel = this.panels[panelIndex];
        const metrics = this.getSliderMetrics(panel);
        const { cards, track, maxStartIndex } = metrics;
        if (!cards.length || !track) return;

        let nearestIndex = 0;
        let nearestDistance = Infinity;

        cards.forEach((card, index) => {
          if (index > maxStartIndex) return;
          const relativeLeft = card.offsetLeft - track.offsetLeft;
          const distance = Math.abs(relativeLeft - viewport.scrollLeft);
          if (distance < nearestDistance) {
            nearestDistance = distance;
            nearestIndex = index;
          }
        });

        this.panelIndexes.set(panelIndex, nearestIndex);
        if (panelIndex === this.activePanelIndex) this.updateFooter();
      });

      this.scrollFrames.set(panelIndex, frame);
    }

    activatePanel(index, focusTab) {
      if (!this.panels.length || index < 0 || index >= this.panels.length) return;
      this.activePanelIndex = index;

      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === index;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });

      const activePanel = this.panels[index];
      if (this.viewAll) this.viewAll.href = activePanel.dataset.viewAllUrl || '#';

      if (focusTab && this.tabs[index] && document.activeElement?.matches('[data-concern-tab]')) {
        this.tabs[index].focus();
      }

      requestAnimationFrame(() => {
        const metrics = this.getSliderMetrics(activePanel);
        const stored = this.panelIndexes.get(index) || 0;
        const clamped = Math.min(stored, metrics.maxStartIndex);
        this.panelIndexes.set(index, clamped);
        this.scrollToIndex(activePanel, clamped, false);
        this.updateFooter();
      });
    }

    getActivePanel() {
      return this.panels[this.activePanelIndex];
    }

    getCards(panel) {
      return panel ? Array.from(panel.querySelectorAll('[data-product-card]')) : [];
    }

    getSliderMetrics(panel) {
      const viewport = panel?.querySelector('[data-products-viewport]');
      const track = panel?.querySelector('[data-products-track]');
      const cards = this.getCards(panel);
      if (!viewport || !track || !cards.length) {
        return { viewport, track, cards, visibleCount: 1, maxStartIndex: 0 };
      }

      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const cardWidth = cards[0].getBoundingClientRect().width || 1;
      const step = cardWidth + gap;
      const visibleCount = Math.max(1, Math.floor((viewport.clientWidth + gap + 1) / step));
      const maxStartIndex = Math.max(0, cards.length - visibleCount);

      return { viewport, track, cards, visibleCount, maxStartIndex };
    }

    moveProducts(direction) {
      const panel = this.getActivePanel();
      const metrics = this.getSliderMetrics(panel);
      if (!metrics.cards.length) return;

      const currentIndex = this.panelIndexes.get(this.activePanelIndex) || 0;
      const nextIndex = Math.max(0, Math.min(metrics.maxStartIndex, currentIndex + direction));
      if (nextIndex === currentIndex) return;

      this.panelIndexes.set(this.activePanelIndex, nextIndex);
      this.scrollToIndex(panel, nextIndex, true);
      this.updateFooter();
    }

    scrollToIndex(panel, index, smooth) {
      const metrics = this.getSliderMetrics(panel);
      const card = metrics.cards[index];
      if (!metrics.viewport || !metrics.track || !card) return;

      const left = card.offsetLeft - metrics.track.offsetLeft;
      metrics.viewport.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
    }

    updateFooter() {
      const panel = this.getActivePanel();
      const metrics = this.getSliderMetrics(panel);
      const total = metrics.cards.length;
      let currentIndex = total ? (this.panelIndexes.get(this.activePanelIndex) || 0) : 0;
      currentIndex = Math.min(currentIndex, metrics.maxStartIndex);
      this.panelIndexes.set(this.activePanelIndex, currentIndex);

      if (this.currentEl) this.currentEl.textContent = total ? String(currentIndex + 1) : '0';
      if (this.totalEl) this.totalEl.textContent = String(total);

      if (this.progressFill) {
        const positions = Math.max(1, metrics.maxStartIndex + 1);
        const progress = total ? ((currentIndex + 1) / positions) * 100 : 0;
        this.progressFill.style.width = `${Math.min(progress, 100)}%`;
      }

      if (this.prevButton) this.prevButton.disabled = total <= metrics.visibleCount || currentIndex <= 0;
      if (this.nextButton) this.nextButton.disabled = total <= metrics.visibleCount || currentIndex >= metrics.maxStartIndex;
    }
  }

  customElements.define('nuup-concern-collection', NuupConcernCollection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('nuup-video-hero-product-rotator')) {

    class NuupVideoHeroProductRotator extends HTMLElement {

      connectedCallback() {

        this.slides = Array.from(this.querySelectorAll('[data-product-slide]'));

        this.dots = Array.from(this.querySelectorAll('[data-product-dot]'));
        this.mobileNext = this.querySelector('[data-mobile-product-next]');

        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));

        this.intervalMs = Number(this.dataset.productInterval) || 5000;

        this.pauseOnHover = this.dataset.pauseOnHover === 'true';

        this.timer = null;

        this.onMouseEnter = this.stop.bind(this);

        this.onMouseLeave = this.start.bind(this);

        this.onVisibilityChange = this.handleVisibility.bind(this);
        this.onMobileNext = () => this.goTo(this.index + 1);
        this.mobileNext?.addEventListener('click', this.onMobileNext);

        if (this.slides.length > 1) {

          if (this.pauseOnHover) {

            this.addEventListener('mouseenter', this.onMouseEnter);

            this.addEventListener('mouseleave', this.onMouseLeave);

          }

          document.addEventListener('visibilitychange', this.onVisibilityChange);

          this.start();

        }

      }



      disconnectedCallback() {

        this.stop();

        this.removeEventListener('mouseenter', this.onMouseEnter);

        this.removeEventListener('mouseleave', this.onMouseLeave);

        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.mobileNext?.removeEventListener('click', this.onMobileNext);

      }



      start() {

        if (this.slides.length < 2) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.stop();

        this.timer = window.setInterval(() => this.goTo(this.index + 1), this.intervalMs);

      }



      stop() {

        if (this.timer) {

          window.clearInterval(this.timer);

          this.timer = null;

        }

      }



      handleVisibility() {

        if (document.hidden) this.stop();

        else this.start();

      }



      goTo(nextIndex) {

        if (!this.slides.length) return;

        this.index = ((nextIndex % this.slides.length) + this.slides.length) % this.slides.length;

        this.slides.forEach((slide, index) => {

          const active = index === this.index;

          slide.classList.toggle('is-active', active);

          slide.setAttribute('aria-hidden', active ? 'false' : 'true');

          if (active) slide.removeAttribute('inert');

          else slide.setAttribute('inert', '');

        });

        this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === this.index));

      }

    }



    customElements.define('nuup-video-hero-product-rotator', NuupVideoHeroProductRotator);

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-accordion"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuup-category-hover')) {
  class NuupCategoryHover extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');

      this.onClick = this.onClick.bind(this);
      this.onPointerOver = this.onPointerOver.bind(this);
      this.onFocusIn = this.onFocusIn.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);

      this.addEventListener('click', this.onClick);
      this.addEventListener('pointerover', this.onPointerOver);
      this.addEventListener('focusin', this.onFocusIn);
      document.addEventListener('shopify:block:select', this.onBlockSelect);

      const initial = this.querySelector('.nca__panel.is-active') || this.panels[0];
      if (initial) this.activate(initial);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('pointerover', this.onPointerOver);
      this.removeEventListener('focusin', this.onFocusIn);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    onClick(event) {
      const trigger = event.target.closest('[data-panel-trigger]');
      if (!trigger || !this.contains(trigger)) return;
      const panel = trigger.closest('[data-panel]');
      if (panel) this.activate(panel);
    }

    onPointerOver(event) {
      if (!this.hoverMedia.matches) return;
      const panel = event.target.closest('[data-panel]');
      if (!panel || !this.contains(panel)) return;
      this.activate(panel);
    }

    onFocusIn(event) {
      const panel = event.target.closest('[data-panel]');
      if (panel && this.contains(panel)) this.activate(panel);
    }

    onBlockSelect(event) {
      const panel = event.target.closest('[data-panel]');
      if (!panel || !this.contains(panel)) return;
      this.activate(panel);
    }

    activate(panel) {
      this.panels.forEach((item) => {
        const active = item === panel;
        item.classList.toggle('is-active', active);

        const trigger = item.querySelector('[data-panel-trigger]');
        const tray = item.querySelector('.nca__product-tray');

        if (trigger) trigger.setAttribute('aria-expanded', active ? 'true' : 'false');
        if (tray) tray.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
    }
  }

  customElements.define('nuup-category-hover', NuupCategoryHover);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-article"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nuup-article')){customElements.define('nuup-article',class extends HTMLElement{
connectedCallback(){
this.controller=new AbortController();const signal=this.controller.signal;const body=this.querySelector('.na-body');if(!body)return;
if(this.dataset.contentTitle==='true'){const first=body.querySelector('h1');if(first){this.querySelector('.na-title').textContent=first.textContent;first.remove();}}
body.querySelectorAll('h1').forEach(h=>{const n=document.createElement('h2');n.innerHTML=h.innerHTML;h.replaceWith(n);});
const heads=[...body.querySelectorAll('h2')];const lists=this.querySelectorAll('[data-na-toc]');lists.forEach(list=>list.replaceChildren());
heads.forEach((h,i)=>{if(!h.id)h.id=this.id+'-heading-'+(i+1);lists.forEach(list=>{const li=document.createElement('li');const a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent;li.append(a);list.append(li);});});
if(heads.length){this.querySelector('.na-index').hidden=false;this.querySelector('.na-mobile-index').hidden=false;}
const update=()=>{const header=document.querySelector('.section-header');const top=header?Math.max(0,header.getBoundingClientRect().bottom):0;this.style.setProperty('--na-top',Math.min(top,220)+'px');const r=body.getBoundingClientRect();const total=Math.max(1,r.height-innerHeight+top);const pct=Math.round(Math.max(0,Math.min(1,(top-r.top)/total))*100);const bar=this.querySelector('.na-progress');if(bar){bar.setAttribute('aria-valuenow',pct);bar.firstElementChild.style.width=pct+'%';}let index=0;heads.forEach((h,i)=>{if(h.getBoundingClientRect().top<=top+50)index=i;});lists.forEach(list=>[...list.querySelectorAll('a')].forEach((a,i)=>{if(i===index)a.setAttribute('aria-current','true');else a.removeAttribute('aria-current');}));};
let queued=false;const schedule=()=>{if(!queued){queued=true;requestAnimationFrame(()=>{update();queued=false;});}};addEventListener('scroll',schedule,{passive:true,signal});addEventListener('resize',schedule,{signal});update();
}
disconnectedCallback(){this.controller?.abort();}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-celebs-editorial"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuup-story-carousel')) {
  customElements.define('nuup-story-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nc__grid');
      this.prev = this.querySelector('[data-nc-prev]');
      this.next = this.querySelector('[data-nc-next]');
      this.count = this.querySelector('.nc__carousel-count');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !matchMedia('(max-width:749px)').matches) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    disconnectedCallback() { this.abort.abort(); this.resize.disconnect(); }
    positions() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const first = this.track.children[0].offsetLeft;
      return Array.from(this.track.children, item => Math.min(max, item.offsetLeft - first));
    }
    index() {
      const positions = this.positions();
      return positions.reduce((best, value, index) => Math.abs(value - this.track.scrollLeft) < Math.abs(positions[best] - this.track.scrollLeft) ? index : best, 0);
    }
    update() {
      const max = this.track.scrollWidth - this.track.clientWidth;
      this.prev.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      this.count.textContent = `${this.index() + 1} / ${this.track.children.length}`;
    }
    move(direction) {
      const positions = this.positions();
      const index = Math.max(0, Math.min(positions.length - 1, this.index() + direction));
      this.track.scrollTo({ left: positions[index], behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-editorial-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nuup-editorial-slider')) {
    class NuupEditorialSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        this.update();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onClick(event) {
        if (!event.target.closest('[data-next]')) return;
        this.goTo(this.index + 1);
      }

      onKeydown(event) {
        if (event.key === 'ArrowRight') this.goTo(this.index + 1);
        if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
      }

      onBlockSelect(event) {
        const slide = event.target.closest('[data-slide]');
        if (!slide || !this.contains(slide)) return;
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.goTo(index);
      }

      goTo(nextIndex) {
        if (!this.slides.length) return;
        this.index = ((nextIndex % this.slides.length) + this.slides.length) % this.slides.length;
        this.update();
      }

      update() {
        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if (active) slide.removeAttribute('inert');
          else slide.setAttribute('inert', '');
        });
      }
    }

    customElements.define('nuup-editorial-slider', NuupEditorialSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-favorites-carousel"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('nuup-favorites-carousel')) {

  class NuupFavoritesCarousel extends HTMLElement {

    connectedCallback() {

      this.viewport =
        this.querySelector(
          '[data-carousel-viewport]'
        );

      this.cards =
        Array.from(
          this.querySelectorAll(
            '[data-carousel-card]'
          )
        );

      this.prev =
        this.querySelector(
          '[data-prev]'
        );

      this.next =
        this.querySelector(
          '[data-next]'
        );

      this.current =
        this.querySelector(
          '[data-current]'
        );

      this.progress =
        this.querySelector(
          '[data-progress-bar]'
        );

      this.index = 0;

      this.raf = null;


      if (
        !this.viewport ||
        this.cards.length === 0
      ) {
        return;
      }


      this.onPrev =
        () =>
          this.goTo(
            this.index - 1
          );


      this.onNext =
        () =>
          this.goTo(
            this.index + 1
          );


      this.onScroll =
        () => {

          if (this.raf) {
            return;
          }


          this.raf =
            requestAnimationFrame(
              () => {

                this.raf = null;

                this.syncFromScroll();

              }
            );

        };


      this.onResize =
        () =>
          this.goTo(
            this.index,
            false
          );


      this.prev?.addEventListener(
        'click',
        this.onPrev
      );


      this.next?.addEventListener(
        'click',
        this.onNext
      );


      this.viewport.addEventListener(
        'scroll',
        this.onScroll,
        {
          passive: true
        }
      );


      window.addEventListener(
        'resize',
        this.onResize
      );


      this.updateUI();

    }



    disconnectedCallback() {

      this.prev?.removeEventListener(
        'click',
        this.onPrev
      );


      this.next?.removeEventListener(
        'click',
        this.onNext
      );


      this.viewport?.removeEventListener(
        'scroll',
        this.onScroll
      );


      window.removeEventListener(
        'resize',
        this.onResize
      );


      if (this.raf) {

        cancelAnimationFrame(
          this.raf
        );

      }

    }



    cardLeft(index) {

      if (!this.cards[index]) {
        return 0;
      }


      return (
        this.cards[index].offsetLeft
        -
        this.cards[0].offsetLeft
      );

    }



    goTo(
      nextIndex,
      smooth = true
    ) {

      this.index =
        Math.max(
          0,
          Math.min(
            nextIndex,
            this.cards.length - 1
          )
        );


      this.viewport.scrollTo({

        left:
          this.cardLeft(
            this.index
          ),

        behavior:
          smooth
            ? 'smooth'
            : 'auto'

      });


      this.updateUI();

    }



    syncFromScroll() {

      const position =
        this.viewport.scrollLeft;


      let nearestIndex = 0;

      let nearestDistance =
        Infinity;


      this.cards.forEach(
        (
          card,
          index
        ) => {

          const distance =
            Math.abs(
              this.cardLeft(index)
              -
              position
            );


          if (
            distance
            <
            nearestDistance
          ) {

            nearestDistance =
              distance;

            nearestIndex =
              index;

          }

        }
      );


      this.index =
        nearestIndex;


      this.updateUI();

    }



    updateUI() {

      const total =
        this.cards.length;


      const current =
        this.index + 1;


      const ratio =
        total > 0
          ? current / total
          : 0;


      if (this.current) {

        this.current.textContent =
          String(current);

      }


      if (this.progress) {

        this.progress.style.transform =
          `scaleX(${ratio})`;

      }


      if (this.prev) {

        this.prev.disabled =
          this.index === 0;

      }


      if (this.next) {

        this.next.disabled =
          this.index ===
          total - 1;

      }

    }

  }


  customElements.define(
    'nuup-favorites-carousel',
    NuupFavoritesCarousel
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-iconos-colecciones"] && !Shopify.designMode) return;
  try {
    



if (!customElements.get('nuup-icon-collection-carousel')) {



  class NuupIconCollectionCarousel extends HTMLElement {



    connectedCallback() {



      this.viewport =

        this.querySelector(

          '[data-icons-viewport]'

        );



      this.items =

        Array.from(

          this.querySelectorAll(

            '[data-icons-item]'

          )

        );



      this.prev =

        this.querySelector(

          '[data-icons-prev]'

        );



      this.next =

        this.querySelector(

          '[data-icons-next]'

        );



      this.raf = null;





      if (

        !this.viewport ||

        this.items.length === 0

      ) {

        return;

      }





      this.onPrev =

        () =>

          this.move(-1);





      this.onNext =

        () =>

          this.move(1);





      this.onScroll =

        () => {



          if (this.raf) {

            return;

          }





          this.raf =

            requestAnimationFrame(

              () => {



                this.raf = null;



                this.updateButtons();



              }

            );



        };





      this.onResize =

        () =>

          this.updateButtons();





      this.prev?.addEventListener(

        'click',

        this.onPrev

      );





      this.next?.addEventListener(

        'click',

        this.onNext

      );





      this.viewport.addEventListener(

        'scroll',

        this.onScroll,

        {

          passive: true

        }

      );





      window.addEventListener(

        'resize',

        this.onResize

      );





      this.updateButtons();



    }







    disconnectedCallback() {



      this.prev?.removeEventListener(

        'click',

        this.onPrev

      );





      this.next?.removeEventListener(

        'click',

        this.onNext

      );





      this.viewport?.removeEventListener(

        'scroll',

        this.onScroll

      );





      window.removeEventListener(

        'resize',

        this.onResize

      );





      if (this.raf) {



        cancelAnimationFrame(

          this.raf

        );



      }



    }







    getStep() {



      if (

        this.items.length > 1

      ) {



        return (

          this.items[1].offsetLeft

          -

          this.items[0].offsetLeft

        );



      }





      return (

        this.items[0]

          ?.getBoundingClientRect()

          .width

        ||

        0

      );



    }







    move(direction) {



      if (!this.viewport) {

        return;

      }





      const step =

        this.getStep();





      if (!step) {

        return;

      }





      this.viewport.scrollBy({



        left:

          direction

          *

          step,



        behavior:

          'smooth'



      });



    }







    updateButtons() {



      if (!this.viewport) {

        return;

      }





      const maxScroll =

        Math.max(

          0,

          this.viewport.scrollWidth

          -

          this.viewport.clientWidth

        );





      const current =

        this.viewport.scrollLeft;





      if (this.prev) {



        this.prev.disabled =

          current <= 2;



      }





      if (this.next) {



        this.next.disabled =

          current >=

          maxScroll - 2;



      }



    }



  }





  customElements.define(

    'nuup-icon-collection-carousel',

    NuupIconCollectionCarousel

  );



}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-ingredientes-interactivo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuup-ingredients-gallery')) {
  class NuupIngredientsGallery extends HTMLElement {
    connectedCallback() {
      this.cards = Array.from(this.querySelectorAll('[data-ingredient-card]'));
      this.viewport = this.querySelector('[data-gallery-viewport]');
      if (!this.cards.length) return;

      this.handleClick = (event) => {
        const trigger = event.target.closest('[data-ingredient-trigger]');
        if (!trigger || !this.contains(trigger)) return;
        const card = trigger.closest('[data-ingredient-card]');
        const index = this.cards.indexOf(card);
        if (index >= 0) this.setActive(index, true);
      };

      this.handleBlockSelect = (event) => {
        const card = event.target?.closest?.('[data-ingredient-card]');
        if (!card || !this.contains(card)) return;
        const index = this.cards.indexOf(card);
        if (index >= 0) this.setActive(index, true);
      };

      this.addEventListener('click', this.handleClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);

      const requested = Math.max(0, Number(this.dataset.initialActive || 1) - 1);
      const initial = Math.min(requested, this.cards.length - 1);
      this.setActive(initial, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    setActive(index, shouldScroll) {
      this.cards.forEach((card, cardIndex) => {
        const active = cardIndex === index;
        card.classList.toggle('is-active', active);
        const trigger = card.querySelector('[data-ingredient-trigger]');
        const description = card.querySelector('[data-ingredient-description]');
        if (trigger) trigger.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (description) description.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (shouldScroll && window.matchMedia('(max-width: 989px)').matches) {
        const card = this.cards[index];
        if (!card) return;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        card.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }
  }

  customElements.define('nuup-ingredients-gallery', NuupIngredientsGallery);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-moving-marquee"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('nuup-marquee-loop')) {

  class NuupMarqueeLoop extends HTMLElement {

    connectedCallback() {

      this.viewport =
        this.querySelector(
          '[data-marquee-viewport]'
        );

      this.track =
        this.querySelector(
          '[data-marquee-track]'
        );

      this.source =
        this.querySelector(
          '[data-marquee-source]'
        );


      if (
        !this.viewport ||
        !this.track ||
        !this.source
      ) {
        return;
      }


      this.rebuild =
        this.rebuild.bind(this);


      this.resizeObserver =
        new ResizeObserver(
          this.rebuild
        );


      this.resizeObserver.observe(
        this.viewport
      );


      this.resizeObserver.observe(
        this.source
      );


      requestAnimationFrame(
        this.rebuild
      );

    }



    disconnectedCallback() {

      if (
        this.resizeObserver
      ) {

        this.resizeObserver.disconnect();

      }

    }



    cleanClone(clone) {

      clone.setAttribute(
        'aria-hidden',
        'true'
      );


      clone.setAttribute(
        'data-marquee-clone',
        'true'
      );


      const nodes = [
        clone,
        ...clone.querySelectorAll('*')
      ];


      nodes.forEach((node) => {

        if (node.id) {

          node.removeAttribute(
            'id'
          );

        }


        Array.from(
          node.attributes
        ).forEach(
          (attribute) => {

            if (
              attribute.name.startsWith(
                'data-shopify-editor'
              )
            ) {

              node.removeAttribute(
                attribute.name
              );

            }

          }
        );

      });


      return clone;

    }



    rebuild() {

      if (
        !this.viewport ||
        !this.track ||
        !this.source
      ) {
        return;
      }


      /*
        Detenemos temporalmente
        la animación.
      */

      this.track.classList.remove(
        'is-ready'
      );


      /*
        Eliminamos las copias
        anteriores.
      */

      this.track
        .querySelectorAll(
          '[data-marquee-clone]'
        )
        .forEach(
          (clone) => clone.remove()
        );


      /*
        Medimos el ancho REAL
        del grupo original.
      */

      const sourceWidth =
        this.source
          .getBoundingClientRect()
          .width;


      const viewportWidth =
        this.viewport
          .getBoundingClientRect()
          .width;


      if (
        !sourceWidth ||
        !viewportWidth
      ) {
        return;
      }


      /*
        Distancia exacta de
        movimiento.

        Cuando termina la animación,
        el primer clon está exactamente
        donde estaba el original.
      */

      this.track.style.setProperty(
        '--nm-shift',
        `${-sourceWidth}px`
      );


      /*
        El track siempre debe ser
        suficientemente largo para
        cubrir la pantalla mientras
        se mueve.

        Por eso duplicamos el grupo
        automáticamente tantas veces
        como haga falta.
      */

      const minimumWidth =
        viewportWidth +
        sourceWidth;


      let safety = 0;


      while (
        this.track.scrollWidth <
        minimumWidth &&
        safety < 12
      ) {

        const clone =
          this.cleanClone(
            this.source.cloneNode(true)
          );


        this.track.appendChild(
          clone
        );


        safety += 1;

      }


      /*
        Siempre necesitamos
        al menos una copia.
      */

      if (
        !this.track.querySelector(
          '[data-marquee-clone]'
        )
      ) {

        const clone =
          this.cleanClone(
            this.source.cloneNode(true)
          );


        this.track.appendChild(
          clone
        );

      }


      /*
        Reactivamos el loop.
      */

      requestAnimationFrame(
        () => {

          this.track.classList.add(
            'is-ready'
          );

        }
      );

    }

  }


  customElements.define(
    'nuup-marquee-loop',
    NuupMarqueeLoop
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuup-product"] && !Shopify.designMode) return;
  try {
    
function nuupDeliveryDates(now=new Date()){
  const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Mexico_City',year:'numeric',month:'numeric',day:'numeric'}).formatToParts(now);
  const value=type=>Number(parts.find(part=>part.type===type).value);
  const visit=new Date(Date.UTC(value('year'),value('month')-1,value('day')));
  const add=count=>{const date=new Date(visit);let elapsed=0;while(elapsed<count){date.setUTCDate(date.getUTCDate()+1);if(date.getUTCDay()!==0)elapsed++;}return date;};
  return [add(3),add(5)];
}
function initNuupProduct(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const form=root.querySelector('.np-app-purchase form'),variants=root.querySelector('[data-np-variant-data]'),track=root.querySelector('.np-track');
  root.querySelectorAll('[data-pickup-details]').forEach(details=>{const summary=details.querySelector('summary');const sync=()=>summary.setAttribute('aria-expanded',String(details.open));sync();details.addEventListener('toggle',sync);});
  const estimate=root.querySelector('[data-delivery-estimate]');
  if(estimate){const dates=nuupDeliveryDates();const format=new Intl.DateTimeFormat('es-MX',{timeZone:'UTC',day:'numeric',month:'long',...(dates[0].getUTCFullYear()!==dates[1].getUTCFullYear()?{year:'numeric'}:{})});estimate.textContent='Recíbelo entre el '+format.format(dates[0])+' y el '+format.format(dates[1]);}
  const primary=root.querySelector('[data-gallery-primary]'),toggle=root.querySelector('[data-gallery-toggle]');
  const galleryImages=track?[...track.querySelectorAll('[data-image-id]')]:[];
  let selectedImage=galleryImages[0]?.dataset.imageId,expanded=false,lastVariant=null;
  function updateGallery(imageId){
    const selected=galleryImages.find(image=>image.dataset.imageId===imageId)||galleryImages[0];
    if(!selected||!primary)return;
    if(selectedImage!==selected.dataset.imageId){
      const image=selected.querySelector('img').cloneNode(true);
      image.loading='eager';image.sizes='(min-width: 960px) 620px, 100vw';
      primary.replaceChildren(image);primary.href=selected.href;
      selectedImage=selected.dataset.imageId;
    }
    let visible=0;
    galleryImages.forEach(image=>{const show=image!==selected&&(expanded||visible<2);image.hidden=!show;if(show)visible++;});
    track.dataset.visibleCount=String(visible);
    if(toggle){toggle.setAttribute('aria-expanded',String(expanded));toggle.textContent=expanded?'Ver menos':'Ver todas las fotos';}
  }
  toggle?.addEventListener('click',()=>{expanded=!expanded;updateGallery(selectedImage);if(!expanded)toggle.scrollIntoView({block:'nearest',behavior:'auto'});});
  updateGallery(selectedImage);
  function reflectAppSelection(){const id=form?.querySelector('[name="id"]')?.value;if(!id)return;const option=[...variants.options].find(item=>item.value===id);if(!option)return;root.querySelector('[data-unit-price]').textContent=option.dataset.money;const compare=root.querySelector('[data-compare]');compare.textContent=option.dataset.compare;compare.hidden=!option.dataset.compare;root.querySelector('[data-availability]').textContent=option.dataset.available==='true'?'Disponible':'Agotado';if(id!==lastVariant){lastVariant=id;updateGallery(option.dataset.image);const delivery=root.querySelector('[data-delivery-row]');if(delivery)delivery.hidden=option.dataset.available!=='true'||option.dataset.requiresShipping!=='true';root.querySelectorAll('[data-pickup-variant]').forEach(item=>{item.hidden=item.dataset.pickupVariant!==id;});}}
  root.addEventListener('change',()=>requestAnimationFrame(reflectAppSelection));
  root.addEventListener('click',e=>{if(e.target.closest('.bcpo,kaching-bundle,.kaching-bundles'))requestAnimationFrame(reflectAppSelection);});
  if(form)new MutationObserver(reflectAppSelection).observe(form,{childList:true,subtree:true});
  reflectAppSelection();
  window.addEventListener('load',reflectAppSelection,{once:true});
}
document.querySelectorAll('.nuup-pdp').forEach(initNuupProduct);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.nuup-pdp').forEach(initNuupProduct));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uno"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuup-biotech-slider')) {
class NuupBiotechSlider extends HTMLElement {
connectedCallback() {
this.track = this.querySelector('[data-slider-track]');
this.slides = Array.from(this.querySelectorAll('[data-slider-slide]'));
this.nextButton = this.querySelector('[data-slider-next]');
this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
this.index = 0;
this.pointerStartX = null;

    if (!this.track || this.slides.length === 0) return;

    this.onNext = () => this.goTo(this.index + 1);
    this.onDotClick = (event) => this.goTo(Number(event.currentTarget.dataset.sliderDot));
    this.onKeydown = (event) => {
      if (event.key === 'ArrowRight') this.goTo(this.index + 1);
      if (event.key === 'ArrowLeft') this.goTo(this.index - 1);
    };
    this.onPointerDown = (event) => {
      this.pointerStartX = event.clientX;
    };
    this.onPointerUp = (event) => {
      if (this.pointerStartX === null) return;
      const distance = event.clientX - this.pointerStartX;
      this.pointerStartX = null;
      if (Math.abs(distance) < 45) return;
      this.goTo(distance < 0 ? this.index + 1 : this.index - 1);
    };
    this.onBlockSelect = (event) => {
      const slide = event.target.closest('[data-slider-slide]');
      if (!slide || !this.contains(slide)) return;
      const index = this.slides.indexOf(slide);
      if (index >= 0) this.goTo(index, false);
    };

    this.nextButton?.addEventListener('click', this.onNext);
    this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('pointerdown', this.onPointerDown, { passive: true });
    this.addEventListener('pointerup', this.onPointerUp, { passive: true });
    document.addEventListener('shopify:block:select', this.onBlockSelect);

    this.goTo(0, false);
  }

  disconnectedCallback() {
    this.nextButton?.removeEventListener('click', this.onNext);
    this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
    this.removeEventListener('keydown', this.onKeydown);
    this.removeEventListener('pointerdown', this.onPointerDown);
    this.removeEventListener('pointerup', this.onPointerUp);
    document.removeEventListener('shopify:block:select', this.onBlockSelect);
  }

  goTo(nextIndex, animate = true) {
    if (!this.track || this.slides.length === 0) return;

    const count = this.slides.length;
    this.index = ((nextIndex % count) + count) % count;

    if (!animate) {
      const oldTransition = this.track.style.transition;
      this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
      requestAnimationFrame(() => {
        this.track.style.transition = oldTransition;
      });
    } else {
      this.track.style.transform = `translate3d(-${this.index * 100}%, 0, 0)`;
    }

    this.slides.forEach((slide, index) => {
      const active = index === this.index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      if (active) slide.removeAttribute('inert');
      else slide.setAttribute('inert', '');
    });

    this.dots.forEach((dot, index) => {
      const active = index === this.index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });
  }
}

customElements.define('nuup-biotech-slider', NuupBiotechSlider);

}

  } catch(e) { console.error(e); }
})();
})();
